// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"246":"8f3743bf","290":"27d9cc45","415":"c58721b3","512":"3e8874de","649":"1c29e1b6"}[chunkId] + ".chunk.js";
};